import * as turf from '@turf/turf'
import * as Tool from '../tool'
/**
 * 3d柱状图
 */
export default class Bar3D {
  /**
   *  初始化bar3d
   * @param {*} map mapbox实例
   * @param {String} id 柱状图实例id
   * @param {String} pk -id 柱状图数据主键字段，用于数据和点位映射,
   * @param {String} fileds 柱状图分段字段名称
   * @param {Object} option 配置项
   * @param {Number} option.step 柱状图边数
   * @param {Number} option.size 柱状图的直径
   * @param {Number} option.delay 延迟加载时间
   */
  constructor(id, map, pk = 'id', fileds, { step = 4, size = 1, delay = 0 }) {
    this.step = step
    this.size = size
    this.res = {}
    this.delay = delay
    this.mapbox = map
    this.fileds = fileds
    this.id = id
    this.pk = pk
    this.geoData = []
    this.first = true // 是否第一次加载
    this.popups = null
    return this
  }

  /**
   * 3d柱状图
   * @param {String} res 柱状图点位信息
   * @param {Array} fileds 字段配置
   */
  setGeoData(res) {
    let { pk, step, size, fileds } = this
    this.res = res
    // 柱状图的边数，必须>3
    let steps = step < 3 ? 3 : step
    // 柱状图的直径, 单位为米,默认为1米
    size = size / 1000
    let data = []
    let options = { steps, units: 'kilometers' }
    // 生成柱状图的地理坐标
    for (let d of res.features) {
      // 围绕中心点创建区域闭合曲线
      let points = turf.circle(d.geometry.coordinates, size, options)
      const rotatedOptions = { pivot: d.geometry.coordinates }
      // 旋转25度为正南正北
      const rotatedPoly = turf.transformRotate(points, 25, rotatedOptions)
      rotatedPoly.properties = d.properties
      if (!rotatedPoly.properties[pk]) {
        console.error('点位主键' + pk + '不能为空')
      }
      // 添加多段数据源
      fileds.forEach(item => {
        let properties = {
          type: item.name,
          color: item.color,
          base: 0,
          height: 0
        }
        properties[pk] = d.properties[pk]
        data.push({
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [...rotatedPoly.geometry.coordinates]
          },
          properties
        })
      })
    }
    this.geoData = data
    return this
  }
  /**
   * 添加图层
   * @param {*} data
   */
  addLayer(data) {
    let { id, mapbox, geoData, _getGeoJson } = this
    if (data) {
      geoData = _getGeoJson(data)
    }
    mapbox.addSource(id, {
      type: 'geojson',
      data: { type: 'FeatureCollection', features: geoData }
    })
    // 添加多段柱状图
    mapbox.addLayer({
      id,
      source: id,
      type: 'fill-extrusion',
      minzoom: 12,
      paint: {
        'fill-extrusion-color': ['get', 'color'],
        'fill-extrusion-height': ['get', 'height'],
        'fill-extrusion-base': ['get', 'base'],
        'fill-extrusion-opacity': 0
      }
    })
    if (data) {
      _animate()
      first = false
    }
    return this
  }
  _animate = () => {
    let { id, delay, mapbox } = this
    if (this.first) {
      new Tool.Animate(mapbox, { frame: 20, delay })
        .putPaint(id, 'fill-extrusion-opacity', 0, 1)
        .start()
      this.first = false
    }
  }
  /**
   * 转换数据为图层可用的geojson
   * @param {*} data
   */
  _getGeoJson = data => {
    let { pk, geoData } = this
    let map = new Map()
    // 转换为对象
    data.forEach(dt => {
      let base = 0
      let height = 0
      let id = dt[pk]
      geoData
        .filter(item => item.properties[pk] === id)
        .forEach((item, i) => {
          // 当前点位的数据
          let type = item.properties.type
          height = dt[type]
          if (i === 1) {
            height += geoData[0].properties.height
            base = geoData[0].properties.height
          }
          if (i > 1) {
            height += geoData[i - 1].properties.height
            base += geoData[i - 1].properties.height
          }
          item.properties.height = height
          item.properties.base = base
        })
    })

    return geoData
  }
  /**
   * 更新图层中的数据
   * @param {Array} data
   */
  updateData(data) {
    let { mapbox, id, _getGeoJson, _animate, first } = this
    if (mapbox.getSource(id)) {
      let geo = _getGeoJson(data)
      mapbox.getSource(id).setData({ type: 'FeatureCollection', features: geo })
      _animate()
    }
    return this
  }
  // 为柱状图添加弹出层
  addPopups(htmls, { minZoom = 14 }) {
    let { mapbox, res, pk } = this
    let that = this
    let popups = []
    this.htmls = htmls
    let addPopup = function() {
      if (popups.length > 0) {
        return
      }
      let i = 0
      // 添加弹出层
      for (let d of res.features) {
        let lng = d.geometry.coordinates[0]
        let lat = d.geometry.coordinates[1]
        const popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false,
          className: 'map-popup'
        })
        let html = htmls.find(item => item.propertie[pk] === d.properties[pk])
        if (html) {
          popup
            .setLngLat({ lat, lng })
            .setDOMContent(html.$el)
            .addTo(mapbox)
          popups.push(popup)
        }
        i++
      }
      that.popups = popups
    }
    let removePopup = function() {
      // 添加弹出层
      for (let p of popups) {
        p.remove()
      }
      popups = []
    }
    let fn = () => {
      let zoom = mapbox.getZoom()
      if (zoom > minZoom) {
        addPopup()
      } else {
        removePopup()
      }
    }
    fn()
    mapbox.on('zoom', fn)
    return this
  }
  getPopup() {
    return this.popups
  }
}



// WEBPACK FOOTER //
// ./src/framework/map/layer/Bar3D.js